"use strict";var core=module.exports={version:"2.6.12"};"number"==typeof __e&&(__e=core);